import { OperatingLayout } from "../../../layouts/operating/OperatingLayout";

export const BuildRoadmap = () => {
  return (
    <OperatingLayout pageHeader="Build Roadmap">
      <p>Placeholder</p>
    </OperatingLayout>
  );
};
